(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inn-redoslijed-velicina"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.innSizeOrderReady) return;
  window.innSizeOrderReady = true;

  const selector = [
    '#bcpo .selector-wrapper:not(.bcpo-simple) .single-option-selector[data-option]',
    'variant-selects fieldset.product-form__input',
    'variant-radios fieldset.product-form__input'
  ].join(',');
  const fractions = { '¼': '1/4', '½': '1/2', '¾': '3/4', '⅓': '1/3', '⅔': '2/3' };
  let queued = false;

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00a0/g, ' ').replace(/[–—−]/g, '-').trim().toUpperCase();
  }

  function isSize(group) {
    const wrapper = group.closest('.selector-wrapper') || group;
    const label = wrapper.querySelector('.bcpo-title, .form__label-title, legend');
    const input = group.matches('select') ? group : group.querySelector('select, input[type="radio"]');
    const names = [label ? label.textContent : '', input ? input.name : ''];
    return names.some(value => {
      const name = normalize(value).replace(/^OPTIONS\[(.*)\]$/, '$1').replace(/[:*]/g, '').trim();
      return /^(VELICIN[AE]|BROJ|SIZE|SIZES|SHOE SIZE|CLOTHING SIZE|VELICINA OBUCE|VELICINA ODJECE)$/.test(name);
    });
  }

  function letterRank(value) {
    const key = value.replace(/[\s-]/g, '')
      .replace(/SMALL$/, 'S').replace(/MEDIUM$/, 'M').replace(/LARGE$/, 'L')
      .replace(/^EXTRA/, 'X');
    if (key === 'S') return 0;
    if (key === 'M') return 1;
    if (key === 'L') return 2;
    const repeated = /^(X{1,9})(S|L)$/.exec(key);
    if (repeated) return repeated[2] === 'S' ? -repeated[1].length : 2 + repeated[1].length;
    const numbered = /^([2-9])X(S|L)$/.exec(key);
    if (numbered) return numbered[2] === 'S' ? -Number(numbered[1]) : 2 + Number(numbered[1]);
    return null;
  }

  function numericRank(value) {
    const text = value.replace(/,/g, '.').replace(/\u2044/g, '/')
      .replace(/[¼½¾⅓⅔]/g, fraction => ' ' + fractions[fraction]).trim();
    const mixed = /^(\d+)[\s-]+(\d+)\s*\/\s*(\d+)$/.exec(text);
    if (mixed && Number(mixed[3]) > Number(mixed[2]) && Number(mixed[2]) > 0) {
      const number = Number(mixed[1]) + Number(mixed[2]) / Number(mixed[3]);
      return [number, number];
    }
    if (/^\d+(?:\.\d+)?$/.test(text)) return [Number(text), Number(text)];
    const range = /^(\d+(?:\.\d+)?)\s*[-/]\s*(\d+(?:\.\d+)?)$/.exec(text);
    return range ? [Number(range[1]), Number(range[2])] : null;
  }

  function sizeKey(value) {
    const text = normalize(value);
    const letter = letterRank(text);
    if (letter !== null) return { kind: 'letter', rank: [letter, letter] };
    const pair = text.split(/\s*[/\-]\s*/);
    if (pair.length === 2) {
      const first = letterRank(pair[0]);
      const last = letterRank(pair[1]);
      if (first !== null && last !== null) return { kind: 'letter', rank: [first, last] };
    }
    const age = /^(\d[\d\s.,/\-]*)(MJ(?:ESECI|ECA|ESEC)?|M(?:ONTHS?)?|G(?:OD(?:INA|INE)?)?|Y(?:RS?|EARS?)?)\.?$/.exec(text);
    if (age) {
      const rank = numericRank(age[1].trim());
      if (rank) {
        const factor = /^[GY]/.test(age[2]) ? 12 : 1;
        return { kind: 'age', rank: rank.map(number => number * factor) };
      }
    }
    const number = numericRank(text.replace(/^(EU|EUR|UK|US)\s+/, '').replace(/\s*(EU|EUR|UK|US|CM)$/, '').trim());
    return number ? { kind: 'number', rank: number } : null;
  }

  function reorder(entries) {
    if (entries.length < 2) return;
    const buckets = new Map();
    entries.forEach((entry, index) => {
      entry.index = index;
      entry.key = sizeKey(entry.value);
      if (!entry.key) return;
      if (!buckets.has(entry.key.kind)) buckets.set(entry.key.kind, []);
      buckets.get(entry.key.kind).push(entry);
    });
    buckets.forEach(items => items.sort((a, b) =>
      a.key.rank[0] - b.key.rank[0] || a.key.rank[1] - b.key.rank[1] || a.index - b.index
    ));
    const positions = new Map();
    const ordered = entries.map(entry => {
      if (!entry.key) return entry;
      const kind = entry.key.kind;
      const position = positions.get(kind) || 0;
      positions.set(kind, position + 1);
      return buckets.get(kind)[position];
    });
    if (ordered.every((entry, index) => entry === entries[index])) return;

    const focused = document.activeElement;
    const restoreFocus = entries.some(entry => entry.nodes.some(node => node === focused || node.contains(focused)));
    const radios = entries.map(entry => entry.input).filter(Boolean);
    const checked = radios.map(input => input.checked);
    const parent = entries[0].nodes[0].parentElement;
    const select = parent instanceof HTMLSelectElement ? parent : null;
    const selected = select ? Array.from(select.selectedOptions) : [];
    const anchors = entries.map(entry => {
      const anchor = document.createComment('');
      parent.insertBefore(anchor, entry.nodes[0]);
      return anchor;
    });
    ordered.forEach((entry, index) => {
      entry.nodes.forEach(node => parent.insertBefore(node, anchors[index]));
    });
    anchors.forEach(anchor => anchor.remove());
    radios.forEach((input, index) => {
      if (input.checked !== checked[index]) input.checked = checked[index];
    });
    if (select) {
      Array.from(select.options).forEach(option => { option.selected = selected.includes(option); });
      if (!selected.length) select.selectedIndex = -1;
    }
    if (restoreFocus && document.activeElement !== focused) focused.focus({ preventScroll: true });
  }

  function sortGroup(group) {
    if (!isSize(group)) return;
    const select = group.matches('select') ? group : group.querySelector('select');
    if (select) {
      if (select.querySelector('optgroup')) return;
      reorder(Array.from(select.options).map(option => ({ nodes: [option], value: option.value })));
      return;
    }
    const container = group.querySelector('.product-form__item') || group;
    const entries = [];
    Array.from(container.children).forEach(child => {
      if (child.matches('input[type="radio"]')) {
        const label = child.nextElementSibling;
        if (label && label.tagName === 'LABEL' && label.htmlFor === child.id) {
          entries.push({ nodes: [child, label], input: child, value: child.value });
        }
        return;
      }
      if (child.tagName === 'LABEL') return;
      const inputs = child.querySelectorAll('input[type="radio"]');
      if (inputs.length === 1 && child.querySelector('label')) {
        entries.push({ nodes: [child], input: inputs[0], value: inputs[0].value });
      }
    });
    reorder(entries);
  }

  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      if (record.target instanceof Element && record.target.closest(selector)) return true;
      return Array.from(record.addedNodes).some(node =>
        node instanceof Element && (node.matches(selector) || node.querySelector(selector))
      );
    });
    if (relevant) schedule();
  });

  function scan() {
    queued = false;
    observer.disconnect();
    try {
      document.querySelectorAll(selector).forEach(sortGroup);
    } finally {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', schedule);
})();
  } catch(e) { console.error(e); }
})();

})();
